module.exports = __webpack_public_path__ + "static/k4Res1-309655dbc4fd2be9058fe18c36880526.png";